(function($){
var $ = jQuery = $;

theme.strings = $.extend(theme.strings || {}, {
  addressError: "Error looking up that address",
  addressNoResults: "No results for that address",
  addressQueryLimit: "You have exceeded the Google API usage limit. Consider upgrading to a \u003ca href=\"https:\/\/developers.google.com\/maps\/premium\/usage-limits\"\u003ePremium Plan\u003c\/a\u003e.",
  authError: "There was a problem authenticating your Google Maps API Key."
});

theme.icons = {
  chevronLightLeft: '<svg fill="currentColor" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
  chevronLightRight: '<svg fill="currentColor" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
  arrowLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
  arrowRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>'
};

// Lightbox
theme.fbOpts = { overlayColor: '#fff', padding: 1, margin: 60, overlayOpacity: 0.9 };
theme.lightbox_min_window_width = 768;
theme.lightbox_min_window_height = 580;

theme.loadPageHeaderImage = function(target) {
  // could have been removed
  theme.checkForBannerBehindHeader();
}

theme.unloadPageHeaderImage = function(target) {
}

theme.runMultiCurrency = function() {
  // multi-currency
  if(typeof Currency != 'undefined' && typeof Currency.convertAll != 'undefined' && $('[name=currencies]').length) {
    Currency.convertAll(shopCurrency, $('[name=currencies]').first().val(), theme.money_container);
    theme.onCurrencyChange();
  }
}

theme.Sections = new function(){
  var _ = this;

  var sections = [];
  var instances = [];

  _.init = function(){
    $(document).on('shopify:section:load', function(e){
      // load a new section
      var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
      if(target) {
        _.sectionLoad(target);
      }
    }).on('shopify:section:unload', function(e){
      // unload existing section
      var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
      if(target) {
        _.sectionUnload(target);
      }
    });
  }

  // register a type of section
  _.register = function(type, section){
    sections.push({ type: type, section: section });
    $('[data-section-type="'+type+'"]').each(function(){
      _.sectionLoad(this);
    });
  }

  // load in a section
  _.sectionLoad = function(target){
    var target = target;
    var section = _._sectionForTarget(target);
    if(section !== false) {
      instances.push({
        target: target,
        section: section
      });
      section.onSectionLoad(target);
      $(target).on('shopify:block:select', function(e){
        _._callWith(section, 'onBlockSelect', e.target);
      }).on('shopify:block:deselect', function(e){
        _._callWith(section, 'onBlockDeselect', e.target);
      });
    }
  }

  // unload a section
  _.sectionUnload = function(target){
    var instanceIndex = -1;
    for(var i=0; i<instances.length; i++) {
      if(instances[i].target == target) {
        instanceIndex = i;
      }
    }
    if(instanceIndex > -1) {
      $(target).off('shopify:block:select shopify:block:deselect');
      _._callWith(instances[instanceIndex].section, 'onSectionUnload', target);
      instances.splice(instanceIndex);
    }
  }

  // helpers
  _._callWith = function(object, method, param) {
    if(typeof object[method] === 'function') {
      object[method](param);
    }
  }

  _._themeSectionTargetFromShopifySectionTarget = function(target){
    var $target = $('[data-section-type]:first', target);
    if($target.length > 0) {
      return $target[0];
    } else {
      return false;
    }
  }

  _._sectionForTarget = function(target) {
    var type = $(target).attr('data-section-type');
    for(var i=0; i<sections.length; i++) {
      if(sections[i].type == type) {
        return sections[i].section;
      }
    }
    return false;
  }
}

// Loading third party scripts
theme.scriptsLoaded = [];
theme.loadScriptOnce = function(src, callback) {
  if(theme.scriptsLoaded.indexOf(src) < 0) {
    theme.scriptsLoaded.push(src);
    var tag = document.createElement('script');
    tag.src = src;

    if(typeof callback == 'function') {
      if (tag.readyState) { // IE, incl. IE9
        tag.onreadystatechange = function() {
          if (tag.readyState == "loaded" || tag.readyState == "complete") {
            tag.onreadystatechange = null;
            callback();
          }
        };
      } else {
        tag.onload = function() { // Other browsers
          callback();
        };
      }
    }

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    return true;
  } else {
    if(typeof callback == 'function') {
      callback();
    }
    return false;
  }
}

// Manage videos
theme.VideoManager = new function(){
  var _ = this;

  // Youtube
  _.youtubeVars = {
    incrementor: 0,
    apiReady: false,
    videoData: {},
    toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)'
  };

  _.youtubeApiReady = function() {
    _.youtubeVars.apiReady = true;
    _._loadYoutubeVideos();
  }

  _._loadYoutubeVideos = function(container) {
    if($(_.youtubeVars.toProcessSelector, container).length) {
      if(_.youtubeVars.apiReady) {
        // play those videos
        $(_.youtubeVars.toProcessSelector, container).addClass('video--init').each(function(){
          _.youtubeVars.incrementor++;
          var containerId = 'theme-yt-video-'+_.youtubeVars.incrementor;
          var videoElement = $('<div>').attr('id', containerId).appendTo(this);
          var autoplay = $(this).data('video-autoplay');
          var player = new YT.Player(containerId, {
            height: '390',
            width: '640',
            videoId: $(this).data('video-id'),
            playerVars: {
              iv_load_policy: 3,
              modestbranding: 1,
              autoplay: autoplay ? 1 : 0,
              rel: 0
            },
            events: {
              onReady: _._onYoutubePlayerReady.bind({ autoplay: autoplay }),
              onStateChange: _._onYoutubePlayerStateChange
            }
          });
          _.youtubeVars.videoData[containerId] = {
            id: containerId,
            container: this,
            videoElement: videoElement,
            player: player
          };
        });
      } else {
        // load api
        theme.loadScriptOnce('https://www.youtube.com/iframe_api');
      }
    }
  }

  _._onYoutubePlayerReady = function(event) {
    event.target.setPlaybackQuality('hd1080');
    if(this.autoplay) {
      event.target.mute();
    }
  }

  _._onYoutubePlayerStateChange = function(event) {
  }

  _._getYoutubeVideoData = function(event) {
    return _.youtubeVars.videoData[event.target.h.id];
  }

  _._unloadYoutubeVideos = function(container) {
    for(var dataKey in _.youtubeVars.videoData) {
      var data = _.youtubeVars.videoData[dataKey];
      if($(container).find(data.container).length) {
        data.player.destroy();
        delete _.youtubeVars.videoData[dataKey];
        return;
      }
    }
  }

  // Vimeo
  _.vimeoVars = {
    incrementor: 0,
    apiReady: false,
    videoData: {},
    toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)'
  };

  _.vimeoApiReady = function() {
    _.vimeoVars.apiReady = true;
    _._loadVimeoVideos();
  }

  _._loadVimeoVideos = function(container) {
    if($(_.vimeoVars.toProcessSelector, container).length) {
      if(_.vimeoVars.apiReady) {
        // play those videos
        $(_.vimeoVars.toProcessSelector, container).addClass('video--init').each(function(){
          _.vimeoVars.incrementor++;
          var $this = $(this);
          var containerId = 'theme-vi-video-'+_.vimeoVars.incrementor;
          var videoElement = $('<div>').attr('id', containerId).appendTo(this);
          var autoplay = !!$(this).data('video-autoplay');
          var player = new Vimeo.Player(containerId, {
            id: $(this).data('video-id'),
            width: 640,
            loop: false,
            autoplay: autoplay
          });
          player.ready().then(function(){
            if(autoplay) {
              player.setVolume(0);
            }
            if(player.element && player.element.width && player.element.height) {
              var ratio = parseInt(player.element.height) / parseInt(player.element.width);
              $this.css('padding-bottom', (ratio*100) + '%');
            }
          });
          _.vimeoVars.videoData[containerId] = {
            id: containerId,
            container: this,
            videoElement: videoElement,
            player: player,
            autoPlay: autoplay
          };
        });
      } else {
        // load api
        if(window.define) {
          // workaround for third parties using RequireJS
          theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function(){
            _.vimeoVars.apiReady = true;
            _._loadVimeoVideos();
            window.define = window.tempDefine;
          }, function(){
            window.tempDefine = window.define;
            window.define = null;
          });
        } else {
          theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function(){
            _.vimeoVars.apiReady = true;
            _._loadVimeoVideos();
          });
        }
      }
    }
  }

  _._unloadVimeoVideos = function(container) {
    for(var dataKey in _.vimeoVars.videoData) {
      var data = _.vimeoVars.videoData[dataKey];
      if($(container).find(data.container).length) {
        data.player.unload();
        delete _.vimeoVars.videoData[dataKey];
        return;
      }
    }
  }

  // Compatibility with Sections
  this.onSectionLoad = function(container){
    _._loadYoutubeVideos(container);
    _._loadVimeoVideos(container);

    // play button
    $('.video-container__play, .video-container__overlay-text', container).on('click', function(evt){
      evt.preventDefault();
      // reveal
      var $cover = $(this).closest('.video-container__cover').addClass('video-container__cover--playing');
      // play
      var id = $cover.next().attr('id');
      if(id.indexOf('theme-yt-video') === 0) {
        _.youtubeVars.videoData[id].player.playVideo();
      } else {
        _.vimeoVars.videoData[id].player.play();
      }
    });
  }

  this.onSectionUnload = function(container){
    $('.video-container__play, .video-container__overlay-text', container).off('click');
    _._unloadYoutubeVideos(container);
    _._unloadVimeoVideos(container);
  }
}

// Youtube API callback
window.onYouTubeIframeAPIReady = function() {
  theme.VideoManager.youtubeApiReady();
}

// Manage option dropdowns
theme.productData = {};
theme.OptionManager = new function(){
  var _ = this;

  _._getVariantOptionElement = function(variant, $container) {
    return $container.find('select[name="id"] option[value="' + variant.id + '"]');
  };

  _.selectors = {
    container: '.product',
    gallery: '.product-photos',
    priceArea: '.product-price',
    // HC - change selector for upload button - 19 May '22
    submitButton: 'input[type=submit], button[type=submit]',
    multiOption: '.option-selectors'
  };

  _.strings = {
    priceNonExistent: "Unavailable",
    priceSoldOut: '<span class="productlabel soldout"><span>'+"Out of stock"+'</span></span>',
    buttonDefault: "Add to cart",
    buttonNoStock: "Out of stock",
    buttonNoVariant: "Unavailable"
  };

  _._getString = function(key, variant){
    var string = _.strings[key];
    if(variant) {
      string = string.replace('[PRICE]', '<span class="product-price__amount theme-money">'+Shopify.formatMoney(variant.price, theme.money_format)+'</span>');
    }
    return string;
  }

  _.getProductData = function($form) {
    var productId = $form.data('product-id');
    var data = null;
    if(!theme.productData[productId]) {
      theme.productData[productId] = JSON.parse(document.getElementById('ProductJson-' + productId).innerHTML);
    }
    data = theme.productData[productId];
    if(!data) {
      console.log('Product data missing (id: '+$form.data('product-id')+')');
    }
    return data;
  }

  _.addVariantUrlToHistory = function(variant) {
    if(variant) {
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    }
  }

  _.updateSku = function(variant, $container){
    $container.find('.sku .sku__value').html( variant ? variant.sku : '' );
    $container.find('.sku').toggleClass('sku--no-sku', !variant || !variant.sku);
  }

  _.updateBarcode = function(variant, $container){
    $container.find('.barcode .barcode__value').html( variant ? variant.barcode : '' );
    $container.find('.barcode').toggleClass('barcode--no-barcode', !variant || !variant.barcode);
  }

  _.updateBackorder = function(variant, $container){
    var $backorder = $container.find('.backorder');
    if($backorder.length) {
      if (variant && variant.available) {
        if (variant.inventory_management && _._getVariantOptionElement(variant, $container).data('stock') == 'out') {
          var productData = _.getProductData($backorder.closest('form'));
          $backorder.find('.selected-variant').html(productData.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - '+variant.title) );
          $backorder.show();
        } else {
          $backorder.hide();
        }
      } else {
        $backorder.hide();
      }
    }
  }

  _.updatePrice = function(variant, $container) {
    var $priceArea = $container.find(_.selectors.priceArea);
    $priceArea.removeClass('on-sale');

    if(variant && variant.available == true) {
      var $newPriceArea = $('<div>');
      $('<span class="product-price__amount theme-money">').html(Shopify.formatMoney(variant.price, theme.money_format)).appendTo($newPriceArea);
      if(variant.compare_at_price > variant.price) {
        $newPriceArea.append(' ');
        $('<span class="product-price__compare theme-money">').html(Shopify.formatMoney(variant.compare_at_price, theme.money_format)).appendTo($newPriceArea);
        $priceArea.addClass('on-sale');
      }
      $priceArea.html($newPriceArea.html());
    } else {
      if(variant) {
        $priceArea.html(_._getString('priceSoldOut', variant));
      } else {
        $priceArea.html(_._getString('priceNonExistent', variant));
      }
    }
  }

  _._updateButtonText = function($button, string, variant) {
    $button.each(function(){
      var newVal;
      newVal = _._getString('button' + string, variant);
      // HC - add to bag name instead of add to cart - 19 May '22
      newVal = (newVal == "Add to cart") ? "Add to bag" : newVal;
      
      if(newVal !== false) {
        if($(this).is('input')) {
          $(this).val(newVal);
        } else {
          $(this).html(newVal);
        }
      }
    });
  }

  _.updateButtons = function(variant, $container) {
    var $button = $container.find(_.selectors.submitButton);

    if(variant && variant.available == true) {
      $button.removeAttr('disabled');
      _._updateButtonText($button, 'Default', variant);
    } else {
      $button.attr('disabled', 'disabled');
      if(variant) {
        _._updateButtonText($button, 'NoStock', variant);
      } else {
        _._updateButtonText($button, 'NoVariant', variant);
      }
    }
  }

  _.updateContainerStatusClasses = function(variant, $container) {
    $container.toggleClass('variant-status--unavailable', !variant.available);
    $container.toggleClass('variant-status--backorder', variant.available
      && variant.inventory_management
      && _._getVariantOptionElement(variant, $container).data('stock') == 'out');
  }

  _.initProductOptions = function(originalSelect) {
    $(originalSelect).not('.theme-init').addClass('theme-init').each(function(){
      var $originalSelect = $(this);
      var productData = _.getProductData($originalSelect.closest('form'));

      // change state for original dropdown
      $originalSelect.on('change.themeProductOptions firstrun.themeProductOptions', function(e, variant){
        if($(this).is('input[type=radio]:not(:checked)')) {
          return; // handle radios - only update for checked
        }
        var variant = variant;
        if(!variant && variant !== false) {
          for(var i=0; i<productData.variants.length; i++) {
            if(productData.variants[i].id == $(this).val()) {
              variant = productData.variants[i];
            }
          }
        }
        var $container = $(this).closest(_.selectors.container);

        // update buttons
        _.updateButtons(variant, $container);
        
        // update price (after button, in case price is in button)
        _.updatePrice(variant, $container);

        // variant images
        if (variant && variant.featured_image) {
          $container.find(_.selectors.gallery).trigger('variantImageSelected', variant);
        }

        // extra details
        _.updateBarcode(variant, $container);
        _.updateSku(variant, $container);
        _.updateBackorder(variant, $container);
        _.updateContainerStatusClasses(variant, $container);

        // variant urls
        var $form = $(this).closest('form');
        if($form.data('enable-history-state') && e.type != 'firstrun') {
          _.addVariantUrlToHistory(variant);
        }

        // multi-currency
        theme.runMultiCurrency();
      });

      // split-options wrapper
      $originalSelect.closest(_.selectors.container).find(_.selectors.multiOption).on('change.themeProductOptions', 'select', function(){
        var selectedOptions = [];
        $(this).closest(_.selectors.multiOption).find('select').each(function(){
          selectedOptions.push($(this).val());
        });
        // find variant
        var variant = false;
        for(var i=0; i<productData.variants.length; i++) {
          var v = productData.variants[i];
          var matchCount = 0;
          for(var j=0; j<selectedOptions.length; j++) {
            if(v.options[j] == selectedOptions[j]) {
              matchCount++;
            }
          }
          if(matchCount == selectedOptions.length) {
            variant = v;
            break;
          }
        }
        // trigger change
        if(variant) {
          $originalSelect.val(variant.id);
        }
        $originalSelect.trigger('change', variant);
      });

      // first-run
      $originalSelect.trigger('firstrun');
    });
  }

  _.unloadProductOptions = function(originalSelect) {
    $(originalSelect).each(function(){
      $(this).off('.themeProductOptions');
      $(this).closest(_.selectors.container).find(_.selectors.multiOption).off('.themeProductOptions');
    });
  }
}

// Orphan reduction on reasonable screens
theme.reduceOrphans = function($items) {
  if($(window).width() > 500) {
    $items.each(function(){
      var html = $(this).html();
      var words = html.split(' ');
      if(words.length > 3) {
        var joinedOrphanLength = words[words.length - 2].length + words[words.length - 1].length + 1;
        var isNotLongerThanPrior = html.length > joinedOrphanLength * 2;
        var isDecentLength = joinedOrphanLength < 20;
        if(isNotLongerThanPrior
          && isDecentLength) {
          var idx = html.lastIndexOf(' ');
          var newHtml = html.substr(0, idx) + '&nbsp;' + html.substr(idx + 1);
          $(this).html(newHtml);
        }
      }
    });
  }
}

theme.SlideshowSection = new function(){
  var _ = this;

  this.assessSlideshowOverlayHeight = function(){
    // ensure image is at least as tall as the overlay text
    $('.section--slideshow .overlay').each(function(){
      var vertPad = parseInt($(this).css('padding-top')) + parseInt($(this).css('padding-bottom'));
      var textHeight = $(this).find('.innest').outerHeight();
      var $e = $(this).closest('.banner-image');
      if($e.hasClass('fixed-height')) {
        $e.closest('.slide').css('min-height', textHeight + vertPad);
      } else {
        $e.find('.rimage-wrapper').css('min-height', textHeight + vertPad);
      }
    });
  }

  this.onSectionLoad = function(target){
    theme.reduceOrphans($('.slide-heading, .slide-text', target));

    // Set up the slideshow
    $('.slideshow', target).each(function(){
      var isCarousel = $(this).data('carousel');
      var doFade = $(this).data('transition') == 'fade';
      var doTransitions = true;
      $(this).on('init', function(e, slideshow){
        $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');

        if(doTransitions) {
          // reveal overlays
          $('.slick-active .overlay--transition', this).removeClass('overlay--transition-out').each(function(){
            // match clones
            $(this).closest('.slideshow').find('.slick-clone .block-' + $(this).closest('.slide').data('index') + ' .overlay--transition').removeClass('overlay--transition-out');
          });
        }
      }).on('afterChange setPosition', function(e, slideshow){
        if(doTransitions) {
          // hide overlays when off screen
          $('.slick-slide:not(.slick-active):not(.slick-clone) .overlay--transition', this).addClass('overlay--transition-out').each(function(){
            // match clones
            $(this).closest('.slideshow').find('.slick-clone:not(.slick-active) .block-' + $(this).closest('.slide').data('index') + ' .overlay--transition').addClass('overlay--transition-out');
          });
          // reveal overlays
          $('.slick-active .overlay--transition', this).removeClass('overlay--transition-out').each(function(){
            // match clones (a clone can be active in carousel)
            $(this).closest('.slideshow').find('.block-' + $(this).closest('.slide').data('index') + ' .overlay--transition').removeClass('overlay--transition-out');
          });
        }
      }).slick({
        autoplay: $(this).hasClass('auto-play'),
        fade: !isCarousel && doFade,
        infinite: true,
        slidesToShow: isCarousel ? 2 : 1,
        useTransform: true,
        arrows: true,
        dots: false,
        prevArrow: [
          '<button type="button" class="slick-prev" aria-label="', theme.strings.previous, '">',
          '<span class="desktop-only">',
          theme.icons.chevronLightLeft,
          '</span>',
          '<span class="mobile-only">',
          theme.icons.arrowLeft,
          '</span>',
          '</button>'
        ].join(''),
        nextArrow: [
          '<button type="button" class="slick-next" aria-label="', theme.strings.next, '">',
          '<span class="desktop-only">',
          theme.icons.chevronLightRight,
          '</span>',
          '<span class="mobile-only">',
          theme.icons.arrowRight,
          '</span>',
          '</button>'
        ].join(''),
        autoplaySpeed: 7000, // milliseconds to wait between slides
        responsive: [
          {
            breakpoint: 900,
            settings: {
              fade: doFade,
              slidesToShow: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              fade: doFade,
              arrows: true,
              dots: true,
              slidesToShow: 1
            }
          }
        ]
      });
    });

    $(window).off('.slideshowSection').on('debouncedresize.slideshowSection', _.assessSlideshowOverlayHeight);
    _.assessSlideshowOverlayHeight();
  }

  this.onSectionUnload = function(target){
    $('.slick-slider', target).slick('unslick').off('init afterChange setPosition');
    $(window).off('.slideshowSection');
  }

  this.onBlockSelect = function(target){
    $(target).closest('.slick-slider')
      .slick('slickGoTo', $(target).data('slick-index'))
      .slick('slickPause');
  }

  this.onBlockDeselect = function(target){
    $(target).closest('.slick-slider')
      .slick('slickPlay');
  }
}

theme.BannerIndexSection = new function(){
  this.onSectionLoad = function(target) {
    var target = target;
    theme.checkForBannerBehindHeader();
    theme.SlideshowSection.onSectionLoad(target);
  }

  this.onSectionUnload = function(target) {
    theme.SlideshowSection.onSectionUnload(target);
  }

  this.onBlockSelect = theme.SlideshowSection.onBlockSelect;

  this.onBlockDeselect = theme.SlideshowSection.onBlockDeselect;
}

theme.SlideshowWithTextSection = new function(){
  this.onSectionLoad = function(target){
    $('.slideshow', target).each(function(){
      $(this).on('init', function(){
        $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
      }).slick({
        autoplay: $(this).hasClass('auto-play'),
        fade: $(this).data('transition') == 'fade',
        autoplaySpeed: 7000, // milliseconds to wait between slides
        infinite: true,
        useTransform: true,
        arrows: true,
        prevArrow: [
          '<button type="button" class="slick-prev" aria-label="', theme.strings.previous, '">',
          '<span class="desktop-only">',
          theme.icons.chevronLightLeft,
          '</span>',
          '<span class="mobile-only">',
          theme.icons.arrowLeft,
          '</span>',
          '</button>'
        ].join(''),
        nextArrow: [
          '<button type="button" class="slick-next" aria-label="', theme.strings.next, '">',
          '<span class="desktop-only">',
          theme.icons.chevronLightRight,
          '</span>',
          '<span class="mobile-only">',
          theme.icons.arrowRight,
          '</span>',
          '</button>'
        ].join(''),
        dots: true
      });
    });
  }

  this.onSectionUnload = function(target){
    $('.slick-slider', target).slick('unslick').off('init');
  }

  this.onBlockSelect = function(target){
    $(target).closest('.slick-slider')
      .slick('slickGoTo', $(target).data('slick-index'))
      .slick('slickPause');
  }

  this.onBlockDeselect = function(target){
    $(target).closest('.slick-slider')
      .slick('slickPlay');
  }
}

theme.FeaturedCollectionSection = new function(){
  this.onSectionLoad = function(target){
    $(window).trigger('checkcaptionheights');
  }
}

theme.FeaturedCollectionsSection = new function(){
  this.onSectionLoad = function(target){
    $(window).trigger('checkcaptionheights');
  }
}

theme.ProductTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);
    theme.OptionManager.initProductOptions($('select[name="id"]', target));
    $(window).trigger('checkcaptionheights');
    $('.product-review-summary a', target).on('click', function(e){
      e.preventDefault();
      $('html,body').animate({
        scrollTop: $($(this).attr('href')).offset().top - 120
      }, 1000, 'swing');
    });
  }

  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
    theme.OptionManager.unloadProductOptions($('select[name="id"]', target));
    $('.product-review-summary a', target).off('click');
  }
}

theme.FeaturedProductSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);
    theme.OptionManager.initProductOptions($('select[name="id"]', target));
    $(window).trigger('checkcaptionheights');
  }

  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
    theme.OptionManager.unloadProductOptions($('select[name="id"]', target));
  }
}

theme.TestimonialsSection = new function(){
  var _ = this;

  this.assessTestimonialCarouselLayout = function(){
    $('.testimonials__items.slick-slider').each(function(){
      var containerWidth = $(this).width();
      var itemsSumWidth = 0;
      $(this).find('.slick-slide').each(function(){
        itemsSumWidth += $(this).outerWidth(true) + 1; // defensive rounding
      });
      $(this).toggleClass('slick-slider--center-carousel', itemsSumWidth < containerWidth);
    });
  }

  this.onSectionLoad = function(target){
    var $carousel = $('.testimonials__items', target);

    // initialise carousel
    $carousel.on('afterChange', function(e, slideshow){
      // prepare for caption transition
      var $container = $(this).closest('.testimonials');
      clearTimeout($container.data('captionChangeTimeoutId'));
      clearTimeout($container.data('captionChangeTimeoutId2'));
      var captionToShowEl = $container.find('.testimonials__caption')[$container.find('.slick-current').data('slick-index')];
      $container.find('.testimonials__caption--active').addClass('testimonials__caption--fade-out');
      $container.data(
        'captionChangeTimeoutId',
        setTimeout(function(){
          $(captionToShowEl).addClass('testimonials__caption--active testimonials__caption--fade-out').siblings('.testimonials__caption--active').removeClass('testimonials__caption--active');
          // initiate fade-in after old one has faded out and new one is ready to fade in
          $container.data(
            'captionChangeTimeoutId2',
            setTimeout(function(){
              $(captionToShowEl).removeClass('testimonials__caption--fade-out');
            }, 10)
          );
        }, 400) // matches css transition
      );
    }).slick({
      autoplay: $carousel.data('autoplay'),
      autoplaySpeed: $carousel.data('autoplay-delay'),
      infinite: false,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      useTransform: true,
      arrows: false,
      dots: false
    });

    // focus on click
    $carousel.on('click', '.testimonials__item', function(e){
      e.preventDefault();
      $carousel.slick('slickGoTo', $(this).data('slick-index'));
    });

    // assess if we can centre the carousel or not
    $(window).off('.testimonialsSection').on('debouncedresize.testimonialsSection', _.assessTestimonialCarouselLayout);
    _.assessTestimonialCarouselLayout();
  }

  this.onSectionUnload = function(target){
    $('.slick-slider', target).slick('unslick').off('init afterChange click');
    $(window).off('.testimonialsSection');
  }

  this.onBlockSelect = function(target){
    var $carousel = $(target).closest('.slick-slider');
    if($carousel.data('autoplay')) {
      $carousel.slick('slickGoTo', $(target).data('slick-index')).slick('slickPause');
    }
  }

  this.onBlockDeselect = function(target){
    var $carousel = $(target).closest('.slick-slider');
    if($carousel.data('autoplay')) {
      $carousel.slick('slickPlay');
    }
  }
}

theme.GallerySection = new function(){
  this.onSectionLoad = function(target){
    theme.reduceOrphans($('.overlay__title, .overlay__subheading', target));
  }
}

theme.CollectionTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);

    // Sorting
    var $sortBy = $('#sort-by', target);
    if($sortBy.length > 0) {
      queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      $sortBy.val($sortBy.data('initval')).trigger('change').on('change', function() {
        queryParams.sort_by = $(this).val();
        location.search = $.param(queryParams);
      });
    }

    // set up mobile filter reveal link
    $('.filter-toggle-button', target).on('click', function(e){
      e.preventDefault();

      // hide btn
      var revealBtnContHeight = $(this).outerHeight(true) + 2; // plus 2 for underline style
      $(this).closest('.mobile-filter-reveal').addClass('mobile-filter-reveal--fade-out');

      // prep filters
      var $filters = $(this).closest('.content-main').find('.filters');
      $filters.height(revealBtnContHeight);

      // show filters
      setTimeout(function(){
        $filters.addClass('filters--transition');
        setTimeout(function(){
          $filters.css({
            height: $filters.find('.filters__inner').height() + 'px',
            opacity: 1
          });
        }, 10);
      }, 250);
    });

    $('#filter-tag', target).on('change', function(){
      window.location = $(this).val();
    });

    $(window).trigger('checkcaptionheights');
  }

  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);

    $('#sort-by', target).off('change');
    $('#filter-tag', target).off('change');
    $('.filter-toggle-button', target).off('click');
  }
}

theme.BlogTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);

    $('#filter-tag', target).on('change', function(){
      window.location = $(this).val();
    });

    // set up mobile filter reveal link
    $('.filter-toggle-button', target).on('click', function(e){
      e.preventDefault();

      // hide btn
      var revealBtnContHeight = $(this).outerHeight(true) + 2; // plus 2 for underline style
      $(this).closest('.mobile-filter-reveal').addClass('mobile-filter-reveal--fade-out');

      // prep filters
      var $filters = $(this).closest('.content-main').find('.filters');
      $filters.height(revealBtnContHeight);

      // show filters
      setTimeout(function(){
        $filters.addClass('filters--transition');
        setTimeout(function(){
          $filters.css({
            height: $filters.find('.filters__inner').height() + 'px',
            opacity: 1
          });
        }, 10);
      }, 250);
    });
  }

  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
    $('#filter-tag', target).off('change');
    $('.filter-toggle-button', target).off('click');
  }
}

theme.ArticleTemplateSection = new function(){
  var _ = this;

  // load content products one at a time to avoid spamming requests
  this.loadNextContentProduct = function(target) {
    var $toLoad = $('.content-products [data-lazy-product-handle].prod-block:first', target);
    if($toLoad.length) {
      $.get('/products/' + $toLoad.data('lazy-product-handle') + '/?section_id=product-item', function(response){
        $toLoad.replaceWith($('<div>' + response + '</div>').find('.prod-block'));
        theme.runMultiCurrency();
        $(window).trigger('checkcaptionheights');
        theme.checkForRevealElements();
        // Shopify reviews app
        if(window.SPR && SPR.initDomEls && SPR.loadBadges) {
          SPR.initDomEls();
          SPR.loadBadges();
        }
      }).error(function(){
        $toLoad.remove();
      }).complete(function(){
        _.loadNextContentProduct(target);
      });
    }
  }

  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);
    _.loadNextContentProduct(target);
  }

  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
  }
}

theme.ListCollectionsTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);
    $(window).trigger('checkcaptionheights');
  }

  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
  }
}

theme.NothingButAHeaderImageSection = new function(){
  this.onSectionLoad = theme.loadPageHeaderImage;
  this.onSectionUnload = theme.unloadPageHeaderImage;
}

theme.announcementHeight = 0;
theme.HeaderSection = new function(){
  this.onSectionLoad = function(target){
    // search
    var $searchContainer = $('.header-search__content', target);
    var $searchResultsContainer = $('.header-search__results', target);
    var currentReq = null;
    var searchThrottleDelay = 400;
    var searchThrottleTimeoutId = -1;
    var imageReplaceRegex = {
      search: /(\.[^\.]+)$/,
      replace: '_100x$1'
    };
    var removeResultsAndPrepForMore = function(){
      var $oldResults = $searchResultsContainer.addClass('header-search__results--disband');
      setTimeout(function(){
        $oldResults.remove();
      }, 500);
      $searchResultsContainer = $('<div class="header-search__results">').insertAfter($searchResultsContainer);
    };
    $('.header-search .input-and-button-row__input', target).on('change.themeHeaderSection keyup.themeHeaderSection paste.themeHeaderSection', function(e){
      var $input = $(this);

      // has value changed?
      if($input.val() == $input.data('previous-value')) {
        return;
      }

      // set content state
      $searchContainer.toggleClass('header-search__content--input-entered', $input.val().length > 0);

      // set loading state
      $searchContainer.addClass('header-search__content--loading');

      // fetch after short timeout, to avoid multiple requests after rapid keypresses
      clearTimeout(searchThrottleTimeoutId);

      if($input.val().length == 0) {
        removeResultsAndPrepForMore();
        $searchContainer.removeClass('header-search__content--has-results header-search__content--loading');
        return;
      }

      searchThrottleTimeoutId = setTimeout(function(){
        // avoid overlapping requests - abort and fetch latest
        if(currentReq) {
          currentReq.abort();
        }
        // fetch info
        $input.data('previous-value', $input.val());
        currentReq = $.get(
          '/search/suggest.json',
          {
            "s": $input.val(),
            "resources": {
              "types": ['product'],
              "unavailable_products": 'bury',
              "limit": 6
            }
          },
          function(response){
            removeResultsAndPrepForMore();
            $searchContainer.toggleClass('header-search__content--has-results', response.resources.results.products.length > 0);

            for(var i = 0; i < response.resources.results.products.length; i++) {
              var p = response.resources.results.products[i];
              var $result = $('<a class="search-result__link">').attr('href', p.url);
              $('<div class="search-result__image">').append(
                $('<img>').attr('src', p.image.replace(imageReplaceRegex.search, imageReplaceRegex.replace)).attr('alt', p.title)
              ).appendTo($result);
              var $resultRight = $('<div class="search-result__detail">').appendTo($result);
              $('<div class="search-result__title">').html(p.title).appendTo($resultRight);

              var $price = $('<div class="search-result__price product-price">').appendTo($resultRight);
              if(p.price_max != p.price_min) {
                $('<span class="product-price__from">').html("From").appendTo($price);
                $price.append(' ');
              }
              $('<span class="product-price__amount theme_money">').html(Shopify.formatMoney(p.price_min, theme.money_format)).appendTo($price);
              if(p.compare_at_price_min > p.price_min) {
                $price.append(' ');
                $('<span class="product-price__compare theme_money">').html(Shopify.formatMoney(p.compare_at_price_min, theme.money_format)).appendTo($price);
              }

              $('<div class="search-result">').append($result).appendTo($searchResultsContainer);
            }

            if(response.resources.results.products.length > 0) {
              $('<a class="feature-link">').attr('href', '/search?' + $input.closest('form').serialize())
                .html("See all results")
                .appendTo($searchResultsContainer);
            }
            var $thisSearchResultsContainer = $searchResultsContainer;
            setTimeout(function(){
              $thisSearchResultsContainer.addClass('header-search__results--show');
            }, 10);
          },
          'json'
        )
          .fail(function(response){
            console.log('Error', response);
          })
          .always(function(response){
            currentReq = null;
            $searchContainer.removeClass('header-search__content--loading');
          });
      }, searchThrottleDelay);
    });

    $('.input-with-clear__clear', target).on('click.themeHeaderSection', function(e){
      e.preventDefault();
      $(this).closest('.input-with-clear').find('input').val('').trigger('change');
    });

    // set announcement offset for scroll checks
    var announcement = document.getElementById('announcement_bar')
    if(announcement) {
      theme.announcementHeight = announcement.clientHeight;
      $(window).on('debouncedresize.headerSection', function(){
        theme.announcementHeight = announcement.clientHeight;
      });
    } else {
      theme.announcementHeight = 0;
    }

    // alter classes on scroll for sticky headers
    $('body').removeClass('scrolled-down');
    if($('.pageheader__contents--sticky', target).length) {
      $(window).on('scroll.headerSection', function(){
        if(!$('body').hasClass('scrolled-down') && $(window).scrollTop() > theme.announcementHeight) {
          $('body').css('overflow-anchor', 'none');
          clearTimeout(theme.debouncedWindowScrollOverflowAnchorTimeoutId);
          theme.debouncedWindowScrollOverflowAnchorTimeoutId = setTimeout(function(){
            $('body').css('overflow-anchor', '');
          }, 255);
        }
        $('body').toggleClass('scrolled-down', $(window).scrollTop() > theme.announcementHeight);
      });
    }

    // set up multi-currency flag button proxy
    $('.switcher-flags', target).on('click', '.switcher-flag', function(e){
      e.preventDefault();
      $(this).closest('.switcher').find('select').val($(this).data('value')).trigger('change');
    });
  }

  this.onSectionUnload = function(target){
    $('.header-search .input-and-button-row__input', target).off('.themeHeaderSection');
    $('.input-with-clear__clear', target).off('.themeHeaderSection');
    $('.switcher-flags', target).off('click');
    $(window).off('.headerSection');
  }
}

theme.InstagramSection = new function(){
  this.onSectionLoad = function(target){
    $('.willstagram:not(.willstagram-placeholder)', target).each(function(){
      var user_id = $(this).data('user_id');
      var tag = $(this).data('tag');
      var access_token = $(this).data('access_token');
      var count = $(this).data('count') || 10;
      var $willstagram = $(this);
      var url = '';
      if(typeof user_id != 'undefined') {
        url = 'https://api.instagram.com/v1/users/' + user_id + '/media/recent?count='+count;
      } else if(typeof tag != 'undefined') {
        url = 'https://api.instagram.com/v1/tags/' + tag + '/media/recent?count='+count;
      }
      $.ajax({
        type: "GET",
        dataType: "jsonp",
        cache: false,
        url: url
        + (typeof access_token == 'undefined'? '' : ('&access_token='+access_token)),
        success: function(res) {
          if(typeof res.data != 'undefined') {
            var $itemContainer = $('<div class="willstagram__items grid grid--row-gutters-small">').appendTo($willstagram);
            var limit = Math.min(20, res.data.length);
            for(var i = 0; i < limit; i++) {
              var photo = res.data[i].images.standard_resolution;
              var photo_small = res.data[i].images.low_resolution;
              var caption = res.data[i].caption != null ? res.data[i].caption.text : '';
              $([
                '<div class="column quarter willstagram__item lazyload--placeholder">',
                '<a class="willstagram__link rimage__image cover lazyload fade-in" target="_blank" href="',
                res.data[i].link,
                '" aria-label="', "Open in Instagram",
                '" data-bgset="', photo_small.url.replace('http:', ''),' ', photo_small.width, 'w ', photo_small.height, 'h,',
                photo.url.replace('http:', ''), ' ', photo.width, 'w ', photo.height, 'h" data-sizes="auto" data-parent-fit="cover">',
                '<img class="willstagram__img rimage__image lazyload fade-in" data-src="',
                photo.url.replace('http:', ''),
                '" alt="', "Instagram image",
                '" />',
                '<div class="desc">', caption, '</div>',
                '</a>',
                '</div>'
              ].join('')).appendTo($itemContainer);
            }
          } else if(typeof res.meta !== 'undefined' && typeof res.meta.error_message !== 'undefined') {
            $willstagram.append('<div class="willstagram__error">'+res.meta.error_message+'</div>');
          }
        }
      });
      if(typeof $(this).data('account') != 'undefined') {
        var splSel = $(this).data('account').split('|');
        var $account = $(this).closest(splSel[0]).find(splSel[1]);
        $.ajax({
          type: "GET",
          dataType: "jsonp",
          url: 'https://api.instagram.com/v1/users/self/?access_token='+access_token,
          success: function(res) {
            if(typeof res.data != 'undefined') {
              $('<a>').html('@'+res.data.username).attr({
                href: 'https://www.instagram.com/'+res.data.username,
                target: '_blank'
              }).appendTo($account);
            }
          }
        });
      }
    });
  }
}


theme.CartTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);
    // terms and conditions checkbox
    if($('#cartform input#terms', target).length > 0) {
      $(document).on('click.cartTemplateSection', '#cartform [name="checkout"]:submit, a[href="/checkout"]', function() {
        if($('#cartform input#terms:checked').length == 0) {
          alert("You must agree to the terms and conditions before continuing.");
          return false;
        }
      });
    }
  }

  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
    $(document).off('.cartTemplateSection');
  }
}

theme.MapSection = new function(){
  var _ = this;
  _.config = {
    zoom: 14,
    styles: {
      default: [],
      silver: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}],
      retro: [{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#c9b2a6"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#ae9e90"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}],
      dark: [{"elementType":"geometry","stylers":[{"color":"#212121"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#212121"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#757575"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#181818"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"poi.park","elementType":"labels.text.stroke","stylers":[{"color":"#1b1b1b"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#373737"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#3c3c3c"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#4e4e4e"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#3d3d3d"}]}],
      night: [{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}],
      aubergine: [{"elementType":"geometry","stylers":[{"color":"#1d2c4d"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#8ec3b9"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#1a3646"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#64779e"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#334e87"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#023e58"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#283d6a"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6f9ba5"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#023e58"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#3C7680"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#304a7d"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#2c6675"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#255763"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#b0d5ce"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#023e58"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#283d6a"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#3a4762"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#0e1626"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#4e6d70"}]}]
    }
  };
  _.apiStatus = null;
  _.mapsToLoad = [];

  this.geolocate = function($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  this.createMap = function() {
    var $map = _.$container.find('.map-section__map-container');

    return _.geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: _.config.zoom,
            styles: _.config.styles[_.style],
            center: results[0].geometry.location,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
            zoomControl: true
          };

          _.map = new google.maps.Map($map[0], mapOptions);
          _.center = _.map.getCenter();

          var marker = new google.maps.Marker({
            map: _.map,
            position: _.center,
            clickable: false
          });

          google.maps.event.addDomListener(window, 'resize', function() {
            google.maps.event.trigger(_.map, 'resize');
            _.map.setCenter(_.center);
          });
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = theme.strings.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = theme.strings.addressQueryLimit;
            break;
          default:
            errorMessage = theme.strings.addressError;
            break;
        }

        // Only show error in the theme editor
        if (Shopify.designMode) {
          var $mapContainer = $map.parents('.map-section');

          $mapContainer.addClass('page-width map-section--load-error');
          $mapContainer
            .find('.map-section__wrapper')
            .html(
              '<div class="errors text-center">' + errorMessage + '</div>'
            );
        }
      });
  }

  this.onSectionLoad = function(target){
    // Global function called by Google on auth errors
    window.gm_authFailure = function() {
      if (!Shopify.designMode) return;

      theme.$currentMapContainer.addClass('page-width map-section--load-error');
      theme.$currentMapContainer
        .find('.map-section__wrapper')
        .html(
          '<div class="errors text-center">' + theme.strings.authError + '</div>'
        );
    }

    // create maps
    theme.$currentMapContainer = _.$container = $(target);
    var key = _.$container.data('api-key');
    _.style = _.$container.data('map-style');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (_.apiStatus === 'loaded') {
      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + key
        ).then(function() {
          _.apiStatus = 'loaded';
          _.createMap();
        });
      } else {
        _.createMap();
      }
    } else {
      _.mapsToLoad.push(this);

      if (_.apiStatus !== 'loading') {
        _.apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            _.apiStatus = 'loaded';
            // API has loaded, load all Map instances in queue
            $.each(_.mapsToLoad, function(index, instance) {
              instance.createMap();
            });
          });
        }
      }
    }
  }

  this.onSectionUnload = function(target){
    if (typeof window.google !== 'undefined') {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  }
}

// A generic text notification above an element
theme.showQuickPopup = function(message, $origin){
  var $popup = $('<div class="simple-popup"/>');
  var offs = $origin.offset();
  $popup.html(message).css({ 'left':offs.left, 'top':offs.top }).hide();
  $('body').append($popup);
  $popup.css('margin-top', - $popup.outerHeight() - 10);
  $popup.fadeIn(200).delay(3500).fadeOut(400, function(){
    $(this).remove();
  });
}

$(function($){
  /// Persistent events for nav interaction

  $(document).on('keydown', '.main-menu-toggle', function(e){
    // return or space - toggle menu and move focus
    if(e.which == 13 || e.which == 32) {
      e.preventDefault();
      e.stopPropagation();
      $('html').toggleClass('open-menu');
      if($('html').hasClass('open-menu')) {
        $('#main-menu .main-menu-links a:first').focus();
      } else {
        $('#pageheader .main-menu-toggle').focus();
      }
    }
  });

  $(document).on('click', '.main-menu-toggle', function(e){
    $('html').toggleClass('open-menu');
    e.preventDefault();
  });

  $(document).on('click touchstart touchend', '.open-menu .focus-tint', function(e){
    $('.open-menu').removeClass('open-menu');
    e.preventDefault();
  });

  $(document).on('click touchstart touchend', '.open-search .focus-tint', function(e){
    $('.open-search').removeClass('open-search');
    e.preventDefault();
  });

  var menuPanelTransitionDelay = 300;
  $(document).on('click', '.has-children > .main-menu-link', function(e){
    e.preventDefault();
    $(this).attr('aria-expanded', 'true');
    var $disappearing = $(this).closest('.main-menu-panel').addClass('main-menu-panel--inactive-left');
    var $appearing = $('#' + $(this).attr('aria-controls'));
    var offset = Math.round($('#main-menu-panel .main-menu-list-item').position().top - $('.main-menu-breadcrumbs:first').height());
    $appearing.css('padding-top', offset);
    setTimeout(function(){
      $appearing.removeClass('main-menu-panel--inactive-right');
    }, menuPanelTransitionDelay);
  });

  $(document).on('click', '.main-menu-breadcrumbs__link', function(e){
    e.preventDefault();
    var $appearing = $($(this).attr('href'));
    var $disappearing = $(this).closest('.main-menu-panel').addClass('main-menu-panel--inactive-right');
    if($(this).attr('href') == '#main-menu-panel') {
      // 3rd tier -> 1st tier, hide middle menu
      $('.main-menu-panel--child.main-menu-panel--inactive-left').addClass('main-menu-panel--inactive-right').removeClass('main-menu-panel--inactive-left');
    }
    setTimeout(function(){
      $appearing.removeClass('main-menu-panel--inactive-left');
    }, menuPanelTransitionDelay);
  });

  /// Toggle mini-menu search
  $(document).on('click', '.header-search-toggle', function(e){
    e.preventDefault();
    if( $('body').toggleClass('open-search').hasClass('open-search') ) {
      setTimeout(function(){
        $('.header-search input[name="q"]').focus();
      }, 500);
    }
  });

  /// Gallery
  // variant images
  $(document).on('variantImageSelected', '.product-photos', function(e, data){
    // get image src
    var variantSrc = data.featured_image.src.split('?')[0].replace(/http[s]?:/, '');

    // locate matching thumbnail & click it
    var $thumb = $(this).find('.thumbnails:not(.hidden) a[href^="' + variantSrc + '"]:first');
    $thumb.trigger('click');
  });

  // click a thumbnail
  $(document).on('click', '.product-photos .thumbnails .thumb', function(e){
    e.preventDefault();
    if(!$(this).hasClass('active')) {
      var $mainPhotoCont = $(this).closest('.product-photos').find('.main');
      var $newImg = $(this).clone().removeClass('thumb active');
      $newImg.find('.rimage-wrapper').addClass('lazyload--placeholder').find('img').removeClass('lazyloaded').addClass('lazyload');
      $mainPhotoCont.html($newImg);
      $(this).addClass('active').siblings('.active').removeClass('active');
    }
  });

  // Expand all thumbs into large images
  $(document).on('click', '.product-photos .load-all-thumbs', function(){
    var $cont = $(this).closest('.product-photos').addClass('product-photos--expanded-all');
    var $thumbs = $cont.find('.thumbnails');

    // Revert main image to first thumbnail
    $thumbs.find('.thumb:first').click();

    setTimeout(function(){
      // Remove expanding link
      var $loadButtonCont = $cont.find('.load-all-thumbs').parent();
      if($loadButtonCont.parent().hasClass('thumbnails')) {
        $loadButtonCont = $loadButtonCont.parent();
      }
      var expInitialHeight = $loadButtonCont.outerHeight(true);

      $cont.find('.load-all-thumbs').parent().remove();

      // Do we have lightboxes?
      var usingLightbox = $cont.find('.main a').length > 0;

      // Expanded image container
      var $expandedCont = $('<div class="exp-image-container">').appendTo($cont.find('.main-wrapper')).css('height', expInitialHeight);
      $thumbs.addClass('hidden');

      // Create expanded images
      $thumbs.find('.thumb:not(:first)').each(function(index){
        var $img = $(this).find('.rimage-outer-wrapper').clone();
        $img.find('.rimage-wrapper').addClass('lazyload--placeholder');
        $img.find('img').removeClass('lazyloaded').addClass('lazyload--manual');
        var $row = $('<div class="main exp-image reveal-candidate">');
        if(usingLightbox) {
          $row.append(
            $('<a/>').attr({
              href: $(this).attr('href'),
              title: $(this).attr('title')
            }).append($img)
          );
        } else {
          $row.append($img);
        }
        $row.appendTo($expandedCont);
      });

      // Set new height to transition to, after reflow
      setTimeout(function(){
        var $lastChild = $expandedCont.children().last();
        $expandedCont.css('height', $lastChild.position().top + $lastChild.outerHeight());
      }, 10);
      // set eventual loaded state, and reveal images
      setTimeout(function(){
        $expandedCont.addClass('loaded')
          .css('height', '')
          .find('.lazyload--manual')
          .removeClass('lazyload--manual')
          .addClass('lazyload');
        theme.checkForRevealElements();
      }, 760);
    }, 500);
    return false;
  });

  // Click on main image
  $(document).on('click', '.product-photos .main a', function(e){
    e.preventDefault();
    //Don't do anything if the screen isn't very tall, otherwise, lightbox!
    if($(window).height() >= theme.lightbox_min_window_height && $(window).width() >= theme.lightbox_min_window_width) {
      var $prodPhotoCont = $(this).closest('.product-photos');
      if($prodPhotoCont.find('img').length == 1) {
        //One image only?
        $.colorbox({ href: $(this).attr('href'), maxWidth: '94%' });
      } else {
        //Many images. Dupe thumbs to create a faux-gallery
        var imgSel = $prodPhotoCont.find('.main').length > 1 ? '.main' : '.thumbnails';
        $('#gallery-cont').remove();
        var $galleryCont = $('<div id="gallery-cont"/>').append(
          $prodPhotoCont.find(imgSel).find('a:has(img)').clone().attr({ rel: 'gallery', title: '' })
        ).hide().appendTo('body');
        //Trigger box (on the right one)
        $galleryCont.children().colorbox({maxWidth:'94%'}).filter('[href="'+$(this).attr('href')+'"]').first().click();
      }
    }
  });


  //Ajax add-to-cart
  var shopifyAjaxAddURL = '/cart/add.js';
  var shopifyAjaxCartURL = '/cart.js';
  var shopifyAjaxStorePageURL = '/search';

  $(document).on('submit', 'form[action^="/cart/add"]:not(.noAJAX)', function(e) {
    var $form = $(this);
    //Disable add button
    $form.find(':submit').attr('disabled', 'disabled').each(function(){
      var contentFunc = $(this).is('button') ? 'html' : 'val';
      $(this).data('previous-value', $(this)[contentFunc]())[contentFunc]("Adding...");
    });

    //Add to cart
    $.post(shopifyAjaxAddURL, $form.serialize(), function(itemData) {
      //Enable add button
      $form.find(':submit').each(function(){
        $btn = $(this);
        var contentFunc = $(this).is('button') ? 'html' : 'val';
        //Set to 'DONE', alter button style, wait a few secs, revert to normal
        $btn[contentFunc]("Added to cart");
        setTimeout(function(){
          $btn.removeAttr('disabled')[contentFunc]($btn.data('previous-value'));
        }, 4000);
      });

      //Update header summary
      $.get(shopifyAjaxStorePageURL, function(data){
        var $newDoc = $($.parseHTML('<div>' + data + '</div>'));
        var sels = ['.pageheader .header-items'];
        for(var i=0; i<sels.length; i++) {
          var cartSummarySelector = sels[i];
          var $newCartObj = $newDoc.find(cartSummarySelector);
          var $currCart = $(cartSummarySelector);
          $currCart.replaceWith($newCartObj);
        }
        theme.runMultiCurrency();
      });


    }, 'text').error(function(data) {
      //Enable add button
      var $firstBtn = $form.find(':submit').removeAttr('disabled').each(function(){
        var $btn = $(this);
        var contentFunc = $btn.is('button') ? 'html' : 'val';
        $btn[contentFunc]($btn.data('previous-value'))
      }).first();

      //Not added, show message
      if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
        var jsonRes = $.parseJSON(data.responseText);
        theme.showQuickPopup(jsonRes.description, $firstBtn);
      } else {
        //Some unknown error? Disable ajax and submit the old-fashioned way.
        $form.addClass('noAJAX');
        $form.submit();
      }
    });
    return false;
  });

  /// General lightbox for all
  $('a[rel=lightbox]').colorbox({ maxWidth: '94%' });

  /// Galleries (only on large screens)
  if($(window).height() >= theme.lightbox_min_window_height && $(window).width() >= theme.lightbox_min_window_width) {
    $('a[rel="gallery"]').colorbox({rel:'gallery',maxWidth:'94%'});
  }

  /// Immmediately select contents when focussing on some inputs
  $(document).on('focusin click', 'input.select-on-focus', function(){
    $(this).select();
  }).on('mouseup', 'input.select-on-focus', function(e){
    e.preventDefault(); //Prevent mouseup killing select()
  });

  /// Product blocks should have consistent heights, if that setting is enabled
  
  $(window).on('load debouncedresize checkcaptionheights', function(){
    $('.product-list').each(function(){
      // images and captions, by row
      var $firstBlock = $('.prod-block:first', this).first();
      var productsPerRow = Math.round($firstBlock.parent().width() / $firstBlock.outerWidth(true));

      var $caps = $('.prod-caption', this);
      var $imgs = $('.rimage-outer-wrapper, .placeholder', this);
      var $imgContainers = $('.prod-image-wrap', this);

      for(var i = 0; i < Math.ceil($caps.length / productsPerRow); i++) {
        var $captionsToProcess = $caps.slice(i * productsPerRow, (i + 1) * productsPerRow);
        var tallest = 0;
        $captionsToProcess.each(function(){
          var ch = $(this).children().outerHeight();
          if(ch > tallest) tallest = ch;
        }).height(tallest);

        var $imagesToProcess = $imgs.slice(i * productsPerRow, (i + 1) * productsPerRow);
        var $imgContainersToProcess = $imgContainers.slice(i * productsPerRow, (i + 1) * productsPerRow);
        tallest = 0;
        $imagesToProcess.each(function(){
          var ch = $(this).outerHeight();
          if(ch > tallest) tallest = ch;
        });
        $imgContainersToProcess.height(tallest);
      }
    });
  }).trigger('checkcaptionheights');
  

  window.SPRCallbacks = {
    onBadgeLoad: function(){
      $(window).trigger('checkcaptionheights');
    }
  }

  /// Show newsletter signup response
  if($('.newsletter-response').length > 0) {
    $.colorbox({
      fixed: true,
      html:[
        '<div class="signup-modal-feedback">',
        $('.newsletter-response:first').html(),
        '</div>'
      ].join('')
    });
  }


  /// Reveal transition
  
  theme.checkForRevealElements(true);
  $(window).on('load scroll', theme.checkForRevealElements);
  $(document).on('shopify:section:load shopify:section:unload shopify:section:reorder', theme.checkForRevealElements);
  


  /// Register all sections
  theme.Sections.init();
  theme.Sections.register('header', theme.HeaderSection);
  theme.Sections.register('banner-index', theme.BannerIndexSection);
  theme.Sections.register('slideshow', theme.SlideshowSection);
  theme.Sections.register('slideshow-with-text', theme.SlideshowWithTextSection);
  theme.Sections.register('video', theme.VideoManager);
  theme.Sections.register('featured-collection', theme.FeaturedCollectionSection);
  theme.Sections.register('featured-collections', theme.FeaturedCollectionsSection);
  theme.Sections.register('instagram', theme.InstagramSection);
  theme.Sections.register('product-template', theme.ProductTemplateSection);
  theme.Sections.register('cart-template', theme.CartTemplateSection);
  theme.Sections.register('collection-template', theme.CollectionTemplateSection);
  theme.Sections.register('blog-template', theme.BlogTemplateSection);
  theme.Sections.register('article-template', theme.ArticleTemplateSection);
  theme.Sections.register('search-template', theme.NothingButAHeaderImageSection);
  theme.Sections.register('page-template', theme.NothingButAHeaderImageSection);
  theme.Sections.register('page-contact-template', theme.NothingButAHeaderImageSection);
  theme.Sections.register('page-list-collections-template', theme.ListCollectionsTemplateSection);
  theme.Sections.register('list-collections-template', theme.ListCollectionsTemplateSection);
  theme.Sections.register('featured-product', theme.FeaturedProductSection);
  theme.Sections.register('map', theme.MapSection);
  theme.Sections.register('testimonials', theme.TestimonialsSection);
  theme.Sections.register('gallery', theme.GallerySection);
});

$.extend($.colorbox.settings, {
  previous: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>Left</title><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
  next: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>Right</title><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
  close: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>Close</title><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>'
});

})(theme.jQuery);


/* HC - Swatches functionality - 19 May '22 */
$(function() {
  $('.swatch :radio').change(function() {
    const variant_id = $(this).closest(".swatch-element").attr("data-variant-id");
    
    $(".original-selector[name='id'] option[selected]").removeAttr("selected");
    $(`.original-selector[name='id'] > option[value='${variant_id}']`).attr("selected", "selected");
    $(`.original-selector[name='id']`).trigger( "change" );
  });
  
  // Change buy button label
  $(".product-add button[type='submit']").html("Add to bag");
});


/* HC - Tabs functionality - 19 May '22 */
var allPanels = $('.accordion > dd').hide();

$('.accordion > dt > a').click(function() {
      $(this).parent().find('.accordion_arrow small').toggleClass('open');
  	  $(this).parent().find('.accordion_arrow small').toggleClass('closed');
      $(this).parent().next().slideToggle();
  
      return false;
});
  
$($('.accordion dd')[0]).show();